import {useContext} from "react";
import {Context} from "../components/UserInfoProvider";

// This hook gets current signed in user data
export default () => useContext(Context);